import { gql, useManualQuery } from '@zenbusiness/application-commons-graphql';
import { useCaptureException, ZBError } from '@zenbusiness/application-commons-logging';

export const INVOICE_LINK_QUERY = gql`
  query InvoiceLinkQuery($invoiceId: String!) {
    invoiceLink(invoiceId: $invoiceId) {
      hostedInvoiceUrl
    }
  }
`;

export default function useInvoiceLink(invoiceId) {
  const captureException = useCaptureException();
  const [fetchInvoiceLinkQuery, { loading }] = useManualQuery(INVOICE_LINK_QUERY, {
    variables: {
      invoiceId,
    },
  });

  const fetchInvoiceLink = async () => {
    try {
      const response = await fetchInvoiceLinkQuery();
      return response.data?.invoiceLink?.hostedInvoiceUrl;
    } catch (error) {
      captureException(
        new ZBError(error, {
          message: 'Failed to fetch invoice link',
          contextData: { identifiers: { invoiceId } },
        }),
      );
      return null;
    }
  };

  return {
    fetchInvoiceLink,
    loading,
  };
}
